import { LevelThreshold } from "../core/models/LevelThreshold";

export function getThresholdDescriptionFromKey(key: keyof LevelThreshold) {
  switch (key) {
    case "veryLow":
      return "Lastro";
    case "low":
      return "Estoque de segurança";
    default:
      return "";
  }
}
